import { DateTime } from 'luxon';

// Unified row shape consumed by BackgroundHealthRow / Index:
// { id, source, type, level, message, details, timestamp, occurrenceCount?, lastOccurredAt? }
// `timestamp`/`lastOccurredAt` are Luxon DateTime instances (or null if unparseable).

function parseIso(value) {
  if (!value) return null;
  const dt = DateTime.fromISO(value, { setZone: true });
  return dt.isValid ? dt : null;
}

export function normalizeCronLog(row) {
  return {
    id: 'cron-' + row.id,
    source: 'cron',
    type: row.type,
    level: row.level,
    message: row.message,
    details: row.details || '',
    timestamp: parseIso(row.startedAt),
  };
}

export function normalizeCronSummary(row, index) {
  return {
    id: 'cron-summary-' + index,
    source: 'cron',
    type: row.type,
    level: row.level,
    message: row.message,
    details: '',
    timestamp: parseIso(row.lastOccurredAt),
    occurrenceCount: row.occurrenceCount,
    lastOccurredAt: parseIso(row.lastOccurredAt),
  };
}

function botErrorMessage(row) {
  return (row.operation || '') + (row.operation && row.errorMessage ? ' — ' : '') + (row.errorMessage || '');
}

function botErrorDetails(row) {
  const parts = [];
  if (row.recipientName) parts.push('Кому: ' + row.recipientName);
  if (row.conversationName) parts.push('Тест: ' + row.conversationName);
  if (row.answerText) parts.push('Питання: ' + row.answerText);
  if (row.payload) parts.push(row.payload);
  return parts.join('\n');
}

export function normalizeBotError(row) {
  return {
    id: 'bot-' + row.id,
    source: 'bot',
    type: 'TELEGRAM_SEND',
    level: row.severity === 'WARNING' ? 'WARNING' : 'ERROR',
    message: botErrorMessage(row),
    details: botErrorDetails(row),
    timestamp: parseIso(row.dAdd),
  };
}

export function normalizeBotErrorSummary(row, index) {
  return {
    id: 'bot-summary-' + index,
    source: 'bot',
    type: 'TELEGRAM_SEND',
    level: row.severity === 'WARNING' ? 'WARNING' : 'ERROR',
    message: botErrorMessage(row),
    details: '',
    timestamp: parseIso(row.lastOccurredAt),
    occurrenceCount: row.occurrenceCount,
    lastOccurredAt: parseIso(row.lastOccurredAt),
  };
}

// Only used for the bot-error source, which has no server-side date-range
// filter - CronLog rows are already filtered server-side (see useCronLogFeed).
export function inDateRange(row, dateFrom, dateTo) {
  const ts = row.lastOccurredAt || row.timestamp;
  if (!ts) return true;
  if (dateFrom) {
    const from = DateTime.fromISO(dateFrom).startOf('day');
    if (ts < from) return false;
  }
  if (dateTo) {
    const to = DateTime.fromISO(dateTo).endOf('day');
    if (ts > to) return false;
  }
  return true;
}
